module.exports = __webpack_public_path__ + "img/05_kudo_17.ed378de8.jpg";